/* ==========================================================================
   Carlson Ranch — theme.js
   Lean storefront JS: hero particles, mobile drawer, cart count refresh,
   newsletter feedback. No frameworks.
   ========================================================================== */

(function(){
  'use strict';

  /* -------- Hero ambient particles -------- */
  function spawnParticles(){
    var containers = document.querySelectorAll('.hero__particles');
    if(!containers.length) return;
    var prefersReduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(prefersReduce) return;

    containers.forEach(function(c){
      var count = 14;
      var frag = document.createDocumentFragment();
      for(var i = 0; i < count; i++){
        var s = document.createElement('span');
        var x = Math.random() * 100;
        var dur = 14 + Math.random() * 18;
        var delay = -Math.random() * 20;
        var scale = 0.6 + Math.random() * 1.4;
        s.style.left = x + '%';
        s.style.animationDuration = dur + 's';
        s.style.animationDelay = delay + 's';
        s.style.transform = 'scale(' + scale + ')';
        frag.appendChild(s);
      }
      c.appendChild(frag);
    });
  }

  /* -------- Mobile drawer -------- */
  function bindMobileDrawer(){
    var toggle = document.querySelector('.site-header__toggle');
    var drawer = document.querySelector('.mobile-drawer');
    if(!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('.mobile-drawer__close');

    function open(){
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function(e){
      if(e.target.tagName === 'A') close();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });
  }

  /* -------- Cart count refresh -------- */
  function refreshCartCount(){
    var slots = document.querySelectorAll('[data-cart-count]');
    if(!slots.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        slots.forEach(function(el){
          el.textContent = cart.item_count;
        });
      })
      .catch(function(){ /* silent — Shopify-side count is server-rendered fallback */ });
  }

  /* -------- Product page: thumbnail switcher -------- */
  function bindProductMedia(){
    var thumbs = document.querySelectorAll('.product__media-thumbs button');
    var main = document.querySelector('.product__media-main img');
    if(!thumbs.length || !main) return;
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var src = btn.getAttribute('data-src');
        if(src){
          main.src = src;
        }
        thumbs.forEach(function(b){ b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* -------- Product page: quantity buttons -------- */
  function bindQuantityControls(){
    document.querySelectorAll('[data-qty-control]').forEach(function(group){
      var input = group.querySelector('input[type="number"]');
      var dec = group.querySelector('[data-qty-action="decrement"]');
      var inc = group.querySelector('[data-qty-action="increment"]');
      if(!input) return;
      if(dec) dec.addEventListener('click', function(){
        var v = parseInt(input.value, 10) || 1;
        if(v > 1){ input.value = v - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if(inc) inc.addEventListener('click', function(){
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------- Init -------- */
  function init(){
    spawnParticles();
    bindMobileDrawer();
    refreshCartCount();
    bindProductMedia();
    bindQuantityControls();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
